/**
 * Port of Origin `slugifyFieldKey` (index.html) — key for a Standard-Custom field
 * derived from its label, with `field_{n}` fallback when the label is empty.
 */
export function slugifyFieldKey(label: string, fallbackIdx: number): string {
  const slug = (label || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
  return slug || `field_${fallbackIdx + 1}`
}
